import React from "react";

const DesktopOnly = () => {
    return (
        <div className="DesktopOnly">
            <div className="desktopOnlyModal">
                <h2>
                    This application is optimized for
                    desktop use only.
                </h2>
                <p>
                    Please use a desktop device for the best
                    experience.
                </p>
            </div>
        </div>
    );
};

export default DesktopOnly;
